<template>
	<div>
		<ul class="list">
			<li class="item">
				<div class="title-content">
					<div class="title">
						<img src="@/assets/img-pc/icon5.png">
						<span>收益週表現</span>
					</div>
					<div class="filter-item">按收益金額</div>
				</div>
				<div class="cont-div">

				</div>
			</li>
			<li class="item">
				<div class="title-content">
					<div class="title">
						<img src="@/assets/img-pc/icon5.png">
						<span>殖利率</span>
					</div>
					<div class="filter-item">按收益率</div>
				</div>
				<div class="cont-div">

				</div>
			</li>
			<li class="item">
				<div class="title-content">
					<div class="title">
						<img src="@/assets/img-pc/icon5.png">
						<span>帶單情況</span>
					</div>
					<!-- <div class="filter-item"></div> -->
				</div>
				<div class="cont-div">
					<div class="progress">
						<el-progress :percentage="50" :show-text="false" :stroke-width="10" text-color="#3affcf"
							define-back-color="#db75ff"></el-progress>
						<div class="count">
							<p><span class="name">獲利天數</span> <span class="green">87</span></p>
							<p><span class="name">虧損天數</span> <span class="red">20</span></p>
						</div>
					</div>
					<div class="info-content">
						<p><span class="name">勝率</span><span>102.66%</span></p>
						<p><span class="name">盈虧比</span><span>6</span></p>
						<p><span class="name">平均訂單價值</span><span>15,840.315</span></p>
					</div>
				</div>
			</li>
		</ul>

		<div class="info_box">
			<div class="item">
				<div class="title-content">
					<div class="title">
						<img src="@/assets/img-pc/icon5.png">
						<span>附單員總覽</span>
					</div>
					<!-- <div class="filter-item"></div> -->
				</div>
				<div class="cont-div">
					<div class="info-content">
						<p><span class="name">帶單天數</span><span>623</span></p>
						<p><span class="name">交易員帶單資產(USDT)</span><span>525,767,830.513197</span></p>
						<p><span class="name">帶單規模</span><span>14,440,913.43684</span></p>
						<p><span class="name">目前跟單用户收益(USDT)</span><span>0</span></p>
						<p><span class="name">跟單人數</span><span>2,365/5,000</span></p>
						<p><span class="name">分潤比例</span><span>-%</span></p>
					</div>
					<div class="title-content">
						<div class="title">
							<img src="@/assets/img-pc/icon5.png">
							<span>跟單用户</span>
						</div>
						<!-- <div class="filter-item"></div> -->
					</div>
					<div class="info-content">
						<p><span class="name">累計跟單用户</span><span>13,741</span></p>
						<p><span class="name">近7日人數變化</span><span>23(+0.17%)</span></p>
					</div>
				</div>
			</div>
			<div class="item item2">
				<div class="title-content">
					<div class="title">
						<img src="@/assets/img-pc/icon5.png">
						<span>跟單用户</span>
					</div>
					<div class="filter-item">共2位跟單者</div>
				</div>
				<div class="cont-div">
					<div class="people-item">
						<img src="https://v3.ptdemot.bio/uploads/subp/4a897ff942bb4b61a6417621e65742ec.png" alt=""
							class="avatar">
						<div class="info">
							<p class="profit">
								<span>跟單總額</span>
								<span class="fdsf">878,455 USD</span>
							</p>
							<p class="profit">
								<span>跟單收益</span>
								<span class="green">+15,441 USD</span>
							</p>
						</div>
					</div>
					<div class="people-item">
						<img src="https://v3.ptdemot.bio/uploads/subp/4a897ff942bb4b61a6417621e65742ec.png" alt=""
							class="avatar">
						<div class="info">
							<p class="profit">
								<span>跟單總額</span>
								<span class="fdsf">878,455 USD</span>
							</p>
							<p class="profit">
								<span>跟單收益</span>
								<span class="green">+15,441 USD</span>
							</p>
						</div>
					</div>
					<div class="no-data">沒有更多了</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {};
		},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	.info_box {
		margin-top: 30px;
		display: flex;
		gap: 30px;

		.item {
			width: 430px;
			height: 386px;
			border: 2px solid #252731;
			border-radius: 8px;
			padding: 30px;

			&.item2 {
				flex: 1;

				.filter-item {
					padding: 6px 10px;
					background: #12141e00;
					color: #fff;
					font-size: 16px;
					border-radius: 0px;
					display: flex;
					align-items: center;
				}
			}

			.title-content {
				margin-bottom: 10px;
			}

			.people-item {
				background: #1a1b24;
				border-radius: 8px;
				padding: 16px;
				display: flex;
				align-items: center;
				width: 405px;
				margin-bottom: 20px;

				.info {
					flex: 1;
					color: #888;
					font-size: 14px;

					.profit {
						display: flex;
						justify-content: space-between;
						width: 100%;
						margin: 0;
						margin-bottom: 5px;

						span {
							&:first-child {
								color: #888;
							}

							&.fdsf {
								color: #fff;
							}
						}
					}
				}

				.avatar {
					width: 46px;
					height: 46px;
					border-radius: 50%;
					margin-right: 16px;
				}
			}

			.no-data {
				color: #969799;
				text-align: center;
				margin-top: 30px;
			}
		}
	}

	.list {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: normal;
		justify-content: normal;
		padding: 30px 0 5px;
		flex-wrap: wrap;
		gap: 30px;

		.item {
			flex: none;
			width: 430px;
			height: 300px;
			border-radius: 8px;
			border: 2px solid #252731;
			padding: 30px;

			.progress {
				margin: 15px 0px 20px;

				.count {
					display: flex;
					justify-content: space-between;
					margin-top: 6px;

					p {
						margin: 0;
					}
				}
			}
		}
	}

	.info-content {
		p {
			margin: 0px;
			margin-bottom: 12px;
			display: flex;
			justify-content: space-between;

			.name {
				color: #adadad;
				text-decoration-line: underline;
			}
		}
	}

	.title-content {
		display: flex;
		justify-content: space-between;

		.title {
			font-size: 15px;
			display: flex;
			align-items: center;
			color: #fff;

			img {
				width: 12px;
				height: 12px;
				margin-right: 5px;
			}
		}

		.filter-item {
			padding: 6px 10px;
			background: #12141e;
			color: #fff;
			font-size: 12px;
			border-radius: 8px;
			display: flex;
			align-items: center;
		}
	}

	.green {
		color: #00f0ff !important;
	}

	.red {
		color: #ff4834 !important;
	}
</style>